import PropTypes from 'prop-types';
import orgUnit from './orgUnit';
import clinician from './clinician';
import address from './address';

const NonPatientActivityPropTypeDefault = {
  id: undefined,
  name: null,
  nonPatientActivityTypeId: null,
  clinicianIds: null,
  orgUnitIds: null,
  startTime: null,
  endTime: null,
  selectedDays: null,
  dateFrom: null,
  dateTo: null,
  recurrenceType: null,
  recurEvery: null,
  duration: null,
  notes: null,
  address: null,
};

const NonPatientActivityPropType = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  nonPatientActivityTypeId: PropTypes.number,
  clinicianIds: PropTypes.arrayOf(clinician),
  orgUnitIds: PropTypes.arrayOf(orgUnit),
  startTime: PropTypes.string,
  endTime: PropTypes.string,
  selectedDays: PropTypes.objectOf(PropTypes.objectOf(PropTypes.bool)),
  dateFrom: PropTypes.string,
  dateTo: PropTypes.string,
  recurrenceType: PropTypes.string,
  recurEvery: PropTypes.number,
  duration: PropTypes.number,
  notes: PropTypes.string,
  address,
});

export { NonPatientActivityPropTypeDefault, NonPatientActivityPropType };
